import {
  obterConfiguracaoAdd,
  obterConfiguracaoBase,
  obterConfiguracaoDeletar,
  ObterConfiguracaoEditar,
} from "./configuracao-tabela-base";

export function obterConfiguracaoDadosAdicionais(camposAdicionais) {
  const base = obterConfiguracaoBase();

  return {
    ...base,
    add: obterConfiguracaoAdd(),
    edit: ObterConfiguracaoEditar(),
    delete: obterConfiguracaoDeletar(),
    columns: {
      campo: _obterCampoColunaAdicional(camposAdicionais),
      conteudo: { title: "Conteudo", filter: false },
    },
  };
}

function _obterCampoColunaAdicional(camposAdicionais: any) {
  const edicaoCamposAdicionais = {
    type: "list",
    config: { selectText: "Selecione...", list: camposAdicionais },
  };

  const campoColunaAdicional = {
    title: "Tipo",
    editor: edicaoCamposAdicionais,
    filter: false,
    filterFunction(value, filter) {
      return filter === value;
    },
  };

  return campoColunaAdicional;
}
